// constants
export const authConstants = {
  // REQUEST
  LOGIN_REQUEST: "LOGIN_REQUEST",
  // SUCCESS
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  // FAILURE
  LOGIN_FAILURE: "LOGIN_FAILURE",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS"
};
